{
  "auth": {
    "login": "登录",
    "loginDescription": "请输入您的账号和密码",
    "username": "用户名",
    "password": "密码",
    "rememberMe": "记住我",
    "forgotPassword": "忘记密码？",
    "noAccount": "还没有账号？",
    "createAccount": "立即注册",
    "usernameRequired": "请输入用户名",
    "passwordRequired": "请输入密码",
    "loginSuccess": "登录成功",
    "loginFailed": "登录失败"
  },
  "menu": {
    "dashboard": "仪表盘",
    "userManagement": "用户管理",
    "userList": "用户列表",
    "userRoles": "角色管理",
    "productManagement": "产品管理",
    "productList": "产品列表",
    "productCategories": "产品分类",
    "productBrands": "品牌管理",
    "orderManagement": "订单管理",
    "orderList": "订单列表",
    "orderReturns": "退货管理",
    "systemSettings": "系统设置",
    "siteSettings": "网站设置",
    "paymentSettings": "支付设置",
    "shippingSettings": "物流设置",
    "users": "用户",
    "projects": "项目",
    "payments": "支付",
    "payment-methods": "支付方式",
    "pricing-plans": "价格方案",
    "billing": "账单",
    "auth": "认证",
    "login": "登录",
    "signup": "注册",
    "recover-password": "找回密码",
    "faq": "常见问题",
    "404": "404页面"
  }
}
